/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { useMantineTheme, useComputedColorScheme } from '@mantine/core';

export interface AppPalette {
  background: string;
  surface: string;
  border: string;
  borderSubtle: string;
  textPrimary: string;
  textSecondary: string;
  textMuted: string;
}

export function useAppColors(): AppPalette {
  const theme = useMantineTheme();
  const scheme = useComputedColorScheme('light');
  return theme.other[scheme] as AppPalette;
}

export interface PhaseColors {
  a: string;
  b: string;
  c: string;
}

export function usePhaseColors(): PhaseColors {
  const theme = useMantineTheme();
  const scheme = useComputedColorScheme('light');
  const phaseColors = theme.other.phaseColors as { light: PhaseColors; dark: PhaseColors };
  return scheme === 'dark' ? phaseColors.dark : phaseColors.light;
}

export function useChartSeriesColors(): string[] {
  const theme = useMantineTheme();
  return theme.other.chartSeriesColors as string[];
}
